<header class="header">
  <div class="d-flex align-items-center gap-16">
    <div class="sm-hide" *ngIf="sessionService.isLoggedIn$ | async">
      <app-button
        (click)="sidebarService.toggleMenu()"
        variant="ghost"
        size="icon"
      >
        <app-icon class="header__menu">menu</app-icon>
      </app-button>
    </div>
    <div class="header__title-container">
      <h2 class="header__title">{{ titleService.title$ | async }}</h2>
      <p
        class="header__subtitle"
        *ngIf="titleService.subtitle$ | async as subtitle"
      >
        {{ subtitle }}
      </p>
    </div>
    <ng-content select="[headerExtension]"></ng-content>
  </div>
  <div class="d-flex align-items-center gap-16">
    <ng-content select="[headerButtons]"></ng-content>
  </div>
</header>
